import { Link as RouterLink } from 'react-router-dom';
import { Box, Button, Container, Flex, Heading, Text } from '@chakra-ui/react';
interface CtaBannerProps {
  headline?: string;
  text?: string;
}
export function CtaBanner({
  headline = "Let's Start a Conversation",
  text = 'For business inquiries, partnerships or general questions, contact Futuramy Investment LLC.'
}: CtaBannerProps) {
  return <Box as="section" bg="navy.900" py={{
    base: 16,
    md: 24
  }} data-id="element-57" data-mp="1wadvhy63uwov">
      <Container maxW="1200px" px={{
      base: 6,
      md: 8
    }} data-id="element-58" data-mp="1w9w013r9omi0">
        <Flex direction={{
        base: 'column',
        lg: 'row'
      }} align={{
        base: 'flex-start',
        lg: 'center'
      }} justify="space-between" gap={{
        base: 8,
        lg: 12
      }} data-id="element-59" data-mp="1rbb2jc3eggx9">
          <Box maxW="640px" data-id="element-60" data-mp="1he6awwqsbt92">
            <Heading as="h2" color="white" fontSize={{
            base: '2xl',
            md: '4xl'
          }} lineHeight={1.2} data-id="element-61" data-mp="1hcvbta8ab9oa">
              {headline}
            </Heading>
            <Text mt={5} color="navy.200" fontSize={{
            base: 'md',
            md: 'lg'
          }} fontWeight={300} data-id="element-62" data-mp="5yhms21soo6o">
              {text}
            </Text>
          </Box>
          <Button as={RouterLink} to="/contact" variant="solidLight" size="lg" flexShrink={0} data-id="element-63" data-mp="1b9c6ilvbbmuh">
            Contact Us
          </Button>
        </Flex>
      </Container>
    </Box>;
}